<div class="container" *ngIf="!searchResult.searchResultList || searchResult.searchResultList.length === 0">
  <div class="row search-no-result-container">
    <div class="col search-no-result-col">
      <span class="search-no-result-for" translate="noSearchResultsPattern" [translateParams]="{'0':searchParams.q||''}"></span>

      <hr class="search-no-result-divider"/>

      <ng-container *ngIf="!searchResult.noResultContent">
        <div id="search-no-result-tips-title">
          <p translate="searchTips"></p>
        </div>
        <div id="search-no-result-tips-content">
          <ul>
            <li translate="noResultPageFirstTip"></li>
            <li translate="noResultPageSecondTip"></li>
            <li translate="noResultPageThirdTip"></li>
          </ul>
        </div>
        <div id="search-no-result-popular-title">
          <p translate="popularSearches"></p>
        </div>
        <div id="search-no-result-popular-links">
          <p>
            <a (click)="triggerSearch({q:'LabVIEW', ps:10, pg: 1})">LabVIEW</a>,
            <a (click)="triggerSearch({q:'NI-DAQmx', ps:10, pg: 1})">NI-DAQmx</a>,
            <a (click)="triggerSearch({q:'GPIB-USB-HS', ps:10, pg: 1})">GPIB-USB-HS</a>
          </p>
        </div>

        <form action="https://www.ni.com/contact-us">
          <button class="search-no-result-contact-us-button" translate="contactUsForHelp" (click)="contactUs()"></button>
        </form>
      </ng-container>
      <ng-container *ngIf="searchResult.noResultContent">
        <div [innerHTML]="searchResult.noResultContent"></div>
      </ng-container>
    </div>
  </div>
</div>
